import React, { Component } from "react";
import { Table, Pagination, Col, Row, Input, Select } from "antd";
import { strings } from "../../helpers";
import { Link } from "react-router-dom";
const { Search } = Input;
const { Option } = Select;

export default class TopSpecialitiesView extends Component {
  render() {
    const { specialities } = this.props;

    const columns = [
      {
        title: "Name",
        key: "name",
        align: "left",
        render: record => <div>{record.name}</div>
      },
      {
        title: "No. of doctors",
        key: "email",
        align: "left",
        render: record => <div>{record.count}</div>
      },
      {
        title: "Weekly status",
        key: "phone_number",
        align: "left",
        render: record => (
          <div>
            <div className="text-green">
              Published - {record.published_news}
            </div>
            <div className="text-red">
              Unpublished - {record.unpublished_news}
            </div>
          </div>
        )
      }
    ];
    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={24} className="heading-domain">
              Top Specialities
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              // onRowClick={record => navigateToDoctorDetails(record.id)}
              columns={columns}
              dataSource={specialities}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
      </div>
    );
  }
}
